/* eslint-disable */

// 获取Android版本号
function getAndroidVerion() {
  var ua = navigator.userAgent.toLowerCase()
  var version = null
  if (ua.indexOf('android') > 0) {
    var reg = /android [\d._]+/gi
    var v_info = ua.match(reg)
    version = (v_info + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.') //得到版本号4.2.2
    version = parseInt(version.split('.')[0])// 得到版本号第一位
  }
  return version
}

// 获取iOS版本号
function getIOSersion() {
  var ua = navigator.userAgent.toLowerCase()
  var version = null
  if (ua.indexOf('like mac os x') > 0) {
    var reg = /os [\d._]+/gi
    var v_info = ua.match(reg)
    version = (v_info + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.') //得到版本号9.3.2或者9.0
    version = parseInt(version.split('.')[0]) // 得到版本号第一位
  }
  return version
}

function replaceToAngularHtml(urlPath) {
  var path = window.location.origin + window.location.pathname
  var pathArr = path.split('/')
  pathArr.pop()
  window.location.replace(pathArr.join('/') + urlPath)
}

const andrVersion = getAndroidVerion();
const IOSersion = getIOSersion();
const canUseMicroApp = window.customElements && window.Proxy;
// 获取浏安卓浏览器版本
const chromeVersion = navigator.userAgent.match(/Chrome\/\d+/g);
// 安卓最低兼容的chrom版本
const minChromeVersion = 66;
// 谷歌浏览器版本是否小于66
const isLtChromeMinChromeVersion = chromeVersion &&
    chromeVersion[0] &&
    parseInt(chromeVersion[0].replace('Chrome/', '')) < minChromeVersion;
// 安卓版本大于等于8
const andrVersionGt8 = andrVersion && andrVersion >= 8

if (
    !canUseMicroApp || // 微前端需要支持自定义元素以及Proxy的api
    andrVersion && andrVersion < 8 || // 安卓版本不能小于8
    IOSersion && IOSersion < 12 || // 苹果系统不能小于ios12
    andrVersionGt8 && isLtChromeMinChromeVersion // 大于等于安卓8的系统，浏览器版本不能低于chrom/66
  ) {
  replaceToAngularHtml('/angular_polyfill_index.html#/event/sign-in')
} else {
  replaceToAngularHtml('/main.html')
}
